<!-- <app-menu></app-menu> -->
<po-page-default>
  <app-welcome></app-welcome>
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 selling-products">
    <span class="po-font-text po-clickable back-page" (click)="backHome()">Voltar</span>
    <po-widget>
      <div class="po-row">
        <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7 po-pt-2">
          <span class="po-font-text-bold ">Produtos mais vendidos</span>
          <span class="po-ml-1 po-icon po-icon-exclamation" [p-tooltip]="topTooltip"></span>
          <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" [p-tooltip]="topTooltipExcel" (click)="downloadExcel()"></span>
        </div>
        <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5" *ngIf="!loading">
          <po-select name="select" [ngModel]="productSelected" [p-options]="listProduct" p-placeholder="Produtos"
            (p-change)="recoverProduct($event)">
          </po-select>
        </div>
      </div>
      <div *ngIf="!errorApi">
        <po-table [p-items]="tableItens" [p-columns]="columns" [p-sort]="true" [p-loading]="loading"></po-table>
        <div class="selling-products-container" *ngIf="!loading">
          <div class="po-xl-8 po-lg-8 po-md-8 po-sm-8 po-font-text-bold po-text-right selling-products-total">
            Total
          </div>
          <div class="po-xl-4 po-lg-4 po-md-4 po-sm-4 po-font-text-bold selling-products-value">
            <span>R$ {{ totalSales }}</span>
          </div>
        </div>
      </div>
      <div class="po-text-center po-pt-5" *ngIf="errorApi">
        <app-error [message]="message"></app-error>
      </div>
    </po-widget>
  </div>
</po-page-default>
